import { useEffect, useState } from "react";
import { ResponsiveContainer } from "recharts";
import { GET_INSPECTION_STATUS_TRACKER_REPORT } from "../../../graphql/queries";
import { useLazyQuery } from "@apollo/client";
import PieChartWithActive from "./components/PieChartWithActive";
import RecordsModal, { RecordsFilter } from "../RecordsModal";

const STATUS_TO_CATEGORY: Record<string, RecordsFilter["trackerCategory"]> = {
   "No Defects": "no_defects",
   "Defects Rectified": "rectified",
   "Pending Defects": "pending",
   "Overdue Defects": "overdue",
};

export default function InspectionStatusTrackerChart() {
   const [data, setData] = useState<any[]>([]);
   const [selected, setSelected] = useState<{ title: string; category: RecordsFilter["trackerCategory"] } | null>(null);
   const [getInspectionStatusTracker, { loading }] = useLazyQuery(GET_INSPECTION_STATUS_TRACKER_REPORT, {
      fetchPolicy: "no-cache",
   });

   useEffect(() => {
      getInspectionStatusTracker().then(res => {
         setData(() => {
            return (res.data?.getInspectionStatusTracker || []).map((i: any) => ({
               name: i.status,
               value: i.count,
               color: i.color,
               code: STATUS_TO_CATEGORY[i.status],
            }));
         });
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   return (
      <div style={{ width: "100%", height: 420 }} className="border bottom-1 rounded p-2">
         <h3 style={{ textAlign: "center" }}>Inspection Defects Tracker</h3>
         {loading && <p>Loading ....</p>}
         <ResponsiveContainer>
            <PieChartWithActive
               data={data}
               onSliceClick={(e) => {
                  const cat = (e as any)?.code as RecordsFilter["trackerCategory"];
                  if (cat) setSelected({ title: `Records: ${e.name}`, category: cat });
               }}
            />
         </ResponsiveContainer>
         {selected && (
            <RecordsModal
               title={selected.title}
               filter={{ trackerCategory: selected.category }}
               onClose={() => setSelected(null)}
            />
         )}
      </div>
   );
}
